var map = {
	"./banner/banner.js": [
		4,
		6
	],
	"./breadcrumbs/breadcrumbs.js": [
		5,
		7
	],
	"./card-form/card-form.js": [
		6,
		8
	],
	"./card-help/card-help.js": [
		7,
		9
	],
	"./card-join/card-join.js": [
		8,
		10
	],
	"./card-project/card-project.js": [
		9,
		11
	],
	"./card-team/card-team.js": [
		10,
		12
	],
	"./card-transport/card-transport.js": [
		11,
		13
	],
	"./card-work-image/card-work-image-variant-1.js": [
		13,
		14
	],
	"./card-work-image/card-work-image.js": [
		14,
		15
	],
	"./card-work-number/card-work-number-variant-4.js": [
		15,
		16
	],
	"./card-work-number/card-work-number.js": [
		16,
		17
	],
	"./card-work/card-work.js": [
		12,
		18
	],
	"./connect/connect.js": [
		17,
		19
	],
	"./content/content.js": [
		18,
		20
	],
	"./counter/counter.js": [
		19,
		21
	],
	"./cta-block/cta-block.js": [
		21,
		22
	],
	"./cta/cta.js": [
		20,
		23
	],
	"./footer/footer.js": [
		22,
		24
	],
	"./header/header.js": [
		23,
		25
	],
	"./hero/hero.js": [
		24,
		40,
		26
	],
	"./hr/hr.js": [
		25,
		27
	],
	"./image-text/image-text.js": [
		26,
		28
	],
	"./intro-block/intro-block.js": [
		27,
		1,
		2,
		29
	],
	"./list-block/list-block.js": [
		28,
		30
	],
	"./photo/photo.js": [
		29,
		0,
		31
	],
	"./popup-cta/popup-cta.js": [
		30,
		32
	],
	"./popup-header/popup-header.js": [
		31,
		33
	],
	"./product-detail-content/product-detail-content.js": [
		32,
		0,
		34
	],
	"./project-overview/project-overview.js": [
		33,
		35
	],
	"./tabs-block/tabs-block.js": [
		34,
		0,
		1,
		2,
		4
	],
	"./team/team.js": [
		35,
		0,
		36
	],
	"./text-faq/text-faq.js": [
		36,
		1,
		37
	],
	"./transport/transport.js": [
		37,
		0,
		5
	],
	"./vacancy-overview/vacancy-overview.js": [
		38,
		38
	],
	"./work/work.js": [
		39,
		0,
		39
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2;
module.exports = webpackAsyncContext;